/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function($) {

  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  window.App = {
    modalCurrentPage: 'login', // login, remind, registration

    'offer': {
      init: function () {
        var agreementField = $('#agreementField');
        var logoLaterField = $('#logoLaterField');

        agreementField.on('click', function () {
          $(this).removeClass('is-invalid');
        });

        logoLaterField.on('click', function () {
          if ($(this).is(':checked')) {
            $('.logotype-field')
              .removeClass('is-invalid')
              .attr('disabled', true)
              .val('');
          } else {
            $('.logotype-field').attr('disabled', false);
          }
        });

        $('.logotype-field').on('change', function () {
          $(this).removeClass('is-invalid');
        });

        // $('#offerForm').on('submit', function (e) {
        //   e.preventDefault();
        //   console.log('form submit');
        // });

        $('.offer-count-refresh').on('click', updateOffer);
        $('.offer-count-input').on('blur', updateOffer);
        $('.offer-count-input').on('keydown', function (e) {
          if (e.key === 'Enter') {
            e.preventDefault();
            updateOffer();
          }
        });

        function updateOffer() {
          var data = $('#offerForm').serialize();

          $.post('/offer/update', data)
            .done(function (response) {
              _.each(response.products, function (row, productId) {
                $('#product__' + productId + '-product_price').html(row[1].product_price.toFixed(2).replace('.', ','));
                $('#product__' + productId + '-product_sum').html(row[1].product_sum.toFixed(2).replace('.', ','));
              });
            });
        }
      },

      sendOffer: function () {
        var offerForm = $('#offerForm');
        var agreementField = $('#agreementField');
        var logoLaterField = $('#logoLaterField');
        var isValid = true;

        agreementField.removeClass('is-invalid');
        if (!agreementField.is(':checked')) {
          agreementField.addClass('is-invalid');
          isValid = false;
        }
        if (!logoLaterField.is(':checked')) {
          var logotype1 = $('#logotype1');
          var logotype2 = $('#logotype2');

          if (!logotype1.val() && !logotype2.val()) {
            logotype1.addClass('is-invalid');
            isValid = false;
          }
        }

        if (isValid) {
          offerForm.attr('action', '/offer/mail');
          offerForm.submit();
        }
      }
    },

    // All pages
    'common': {
      currentCategory: null,
      init: function() {

        //phones
        $('.phone-hidden').on('click', function (e) {
          e.preventDefault();
          var idx = $(this).data('phone-idx');

          $('.phone-short[data-phone-idx=' + idx + ']')
            .removeClass('d-none')
            .addClass('d-inline');
          $(this).removeClass('d-inline')
            .addClass('d-none');

          if (window.ga !== undefined) {
            ga('gtm1.send', 'event', {
              eventCategory: 'phone-number-show'
            });
          }
        });

        var $document = $(document),
          $element = $('.header-content'),
          className = 'hasScrolled',
          lastScrollTop = 0;

        $document.scroll(function () {
          var st = jQuery(this).scrollTop();
          if ($document.scrollTop() >= 184) {
            $element.addClass(className);

            // console.log(st, '<', lastScrollTop);
            if (st < lastScrollTop) {
              jQuery('.header-bottom').addClass('hasScrolledTop');
              // jQuery('.megamenu-title').removeClass('active');

            }

          } else {
            $element.removeClass(className);
            jQuery('.header-bottom').removeClass('hasScrolledTop');
            // jQuery('.megamenu-title').addClass('active'); TYLKO NA HOME!
            // jQuery('.megamenu-title').removeClass('active');
          }
          lastScrollTop = st;
        });

          jQuery('body').on('click', '.mb-tap', function(event) {
            event.preventDefault();
            th = jQuery(this);
            if (th.parent().parent().hasClass('smenu')){
              th.parent().parent().removeClass('smenu');
            } else {
              jQuery('.pt_menu').removeClass('smenu');
              th.parent().parent().addClass('smenu');
            }
          });

        $(".pt_menu").mouseover(function() {
          console.log('pt_menu mouseover');
          var wys = $('#pt_vmegamenu').height();
          var catId = jQuery(this).data('id');
          var categoryMenu = $('#cat-' + catId);
          categoryMenu.show();
          categoryMenu.css('min-height', wys+2);
        });
        $(".pt_menu").mouseout(function() {
          var catId = jQuery(this).data('id');
          $('#cat-' + catId).hide();
        });
        $(".megamenu-content").mouseover(function() {
          $(this).show();
        });
        $(".megamenu-content").mouseout(function() {
          $(this).hide();
        });

        // ----------------------
        // product images gallery
        var productImagesZoom = $('#product-images-zoom');
        initEZPlus();
        $(window).on('resize', function () {
          initEZPlus();
        });
        function initEZPlus() {
          productImagesZoom.ezPlus({
              gallery: 'gallery_01',
              cursor: 'pointer',
              galleryActiveClass: 'active',
              borderSize: 2,
              galleryEvent: 'mouseover',
              zoomWindowWidth: 1000,
              zoomWindowHeight: 600,
              zoomWindowOffsetY: -50,
              responsive: true,
              respond: [
                {
                  range: '100-767',
                  enabled: false,
                  showLens: false
                },
                {
                  range: '768-991',
                  zoomWindowWidth: 480,
                  zoomWindowHeight: 300
                },
                {
                  range: '992-1199',
                  zoomWindowWidth: 640,
                  zoomWindowHeight: 420
                },
                {
                  range: '1200-1586',
                  zoomWindowWidth: 800,
                  zoomWindowHeight: 500
                }
              ]
          });
        }
        // obsługa kliknięcia podglądu i wyświetlenia w fancybox gallery
        productImagesZoom.bind('click', function (e) {
          var ez = productImagesZoom.data('ezPlus');

          var galleryList = ez.getGalleryList();
          $.fancyboxPlus(galleryList);

          return false;
        });
        // Obsługa dostępnych kolorów w powiązaniu z galerią
        var availableColors = $('.available-colors a');
        availableColors.on('mouseover', function (e) {
          $(this).addClass('active');
          var ez = productImagesZoom.data('ezPlus');
          ez.swaptheimage($(this).data('image'), $(this).data('zoom-image'));

          $('#color-name').html($(this).data('color-name'));
        });
        availableColors.on('mouseleave', function (e) {
          var firstImage = $('#gallery_01 a.active');
          if (firstImage[0] === undefined) {
            firstImage = $('#gallery_01 :first a');
          }
          if (firstImage[0] === undefined) {
            firstImage = $('.available-colors a:first');
          }

          if (!$(this).hasClass('first')) {
            $(this).removeClass('active');
          }
          var ez = productImagesZoom.data('ezPlus');
          ez.swaptheimage(firstImage.data('image'), firstImage.data('zoom-image'));

          $('#color-name').html($('.available-colors a:first').data('color-name'));
        });
        // end product images gallery
        // --------------------------

          jQuery('body').on('click', '.megamenu-title', function(event) {
            event.preventDefault();
            jQuery(this).toggleClass('active');
          });

        /* techniki nadruku */
        jQuery(".pt-brand-container .ptowl").owlCarousel({
          autoplay: true,
          autoplayHoverPause: true,
          loop: true,
          items: 6,
          responsiveClass: true,
          responsive: {
            0: {
              items: 2
            },
            768: {
              items: 3
            },
            992: {
              items: 4
            },
            1200: {
              items: 5
            },
            1570: {
              items: 6
            }
          },
          slideSpeed: 500,
          paginationSpeed: 500,
          rewindSpeed: 500,
          addClassActive: true,
          nav: true,
          stopOnHover: true,
          dots: false,
          scrollPerPage: true,
          lazyLoad: true
        });

          /* inne kolory produktu */
          jQuery(".product-colors-container .ptowl").owlCarousel({
            items: 6,
            responsiveClass: true,
            responsive: {
              0: {
                items: 3
              },
              576: {
                items: 4
              },
              960: {
                items: 6
              }
            },
            slideSpeed: 500,
            paginationSpeed: 500,
            rewindSpeed: 500,
            addClassActive: true,
            nav: true,
            stopOnHover: true,
            dots: false,
            scrollPerPage: true,
            lazyLoad: true
          });

          jQuery('body').on('click', '.show-color', function(event) {
            //jQuery(this).toggleClass('active');
            jQuery(this).parent().toggleClass('active');
            event.preventDefault();
          });


          /* dodawanie do ofertownika modal */

          var modal = $('#offerModal');
          var loginModal = $('#loginModal');

          modal.find('#offer-submit').on('click', submitOfferAdd);

          $('.offer-add-btn').on('click', function (event) {
            event.preventDefault();

            if (window.userLoggedIn) {
              var countField = $(this).parent().parent().find('input.offer_count');
              if (countField) {
                modal.find('#offercontact-input-count').val(countField.val());
              }
              modal.find('#offercontact-input-product_id').val($(this).data('productid'));
              modal.modal('show');
            } else {
              loginModal.addClass('show-offer-message');
              loginModal.modal('show');
            }
          });

          modal.on('show.bs.modal', function (event) {
            console.log('show.bs.modal');
            clearErrorMessage('offer-form', 'offercontact');
          });

          modal.on('shown.bs.modal', function (event) {
            resetFormErrors();
          });

          function submitOfferAdd(e) {
            e.preventDefault();

            var productId = $('#offercontact-input-product_id').val();
            var handler = $('#offer-btn_' + productId);

            if (!handler.hasClass('active')) {
              var productCount = $('#offercontact-input-count').val();
              var contactData = {
                account_id: parseInt($('#offercontact-account_id').val()),
                short_name: $('#offercontact-input-company_name').val(),
                full_name: $('#offercontact-input-company_name').val(),
                contact_id: parseInt($('#offercontact-contact_id').val()),
                first_name: $('#offercontact-input-contact_name').val(),
                contact_email: $('#offercontact-input-contact_email').val(),
                contact_phone: $('#offercontact-input-contact_phone').val()
              };

              addProductToOffer('/offer/add/id/' + productId, productCount, contactData).then(function (response) {
                clearErrorMessage('offer-form', 'offercontact');
                if (response.status == 1) {
                  /* liczba produktów w ofertowniku */
                  $('.showcart .counter-number').html(response.counter);
                  handler.removeClass('btn-primary');
                  handler.addClass('btn-secondary disabled');
                  handler.attr("title", handler.data('title-in-offer'));
                  handler.html(handler.data('in-offer'));

                  var countField = handler.parent().parent().find('input.offer_count');
                  if (countField) {
                    countField.attr('disabled', true);
                  }

                  $('#offercontact-contact_id').val(response.contact_id);
                  $('#offercontact-account_id').val(response.account_id);
                  $('#offerModal').modal('hide');
                } else {
                  var errors = {};
                  showFormErrors('offercontact', response.validation_errors);
                }
              });
            }
          }

          $('[data-toggle="tooltip"]').tooltip();
          $('[data-toggle="popover"]').popover();

          function clearErrorMessage(formId, type) {
            var errorMessageBox = $('#' + formId + ' #' + type + '-message');
            errorMessageBox.html();
            errorMessageBox.hide();
            var successMessageBox = $('#' + formId + ' #' + type + '-success-message');
            successMessageBox.html();
            successMessageBox.hide();

            $('#' + formId + ' .form-control').removeClass('is-invalid');
            $('#' + formId + ' .custom-control-input').removeClass('is-invalid');
            $('#' + formId + ' .invalid-feedback').html('');
          }

        function showErrorMessage(id, message) {
          var errorMessageBox = $('#' + id);
          errorMessageBox.html(message);
          errorMessageBox.show();
        }

        function showSuccessMessage(id, message) {
          var successMessageBox = $('#' + id);
          successMessageBox.html(message);
          successMessageBox.show();
        }

        function showFormErrors(page, errors) {
          _.forEach(errors, function (val, key) {
            console.log('Add class is-invalid to element: #' + page + '-input-' + key);
            var errorField = $('#' + page + '-input-' + key);
            errorField.addClass('is-invalid');
            console.log(errorField, '#' + page + '-input-' + key);

            var nextEl = errorField.next();
            var joinVals = _.join(_.map(val, function (e) {
              return e;
            }), ', ');
            nextEl.html(joinVals);

            var errorCheckbox = $('#' + page + '-checkbox-' + key);
            errorCheckbox.addClass('is-invalid');

            nextEl = errorCheckbox.next().next();
            joinVals = _.join(_.map(val, function (e) {
              return e;
            }), ', ');
            nextEl.html(joinVals);
          });
        }

        $('.changePage').on('click', function (event) {
          event.preventDefault();
          clearErrorMessage('login-form', 'login');

          showPage($(this).data('page'));
        });

        function showPage(pageToShow, firstLoad) {
          $('#page-' + App.modalCurrentPage).hide();
          $('#page-' + pageToShow).show();
          $('#login-form').find('input[type=text],input[type=password], textarea, select').val('');
          _.each($('#login-form').find('input[type=checkbox]'), function (chk) {
            chk.checked = false;
          });

          if (pageToShow === 'registration') {
            $('#login-form').find('#registration-input-return_url').val(window.location.href);
          }

          $('.handler').hide();
          $('.handler-' + pageToShow).show();
          setTimeout(function () {
            var firstInput = $('.page-' + pageToShow).find('input[type=text],textarea,select').filter(':first');
            console.log(firstInput);
            if (firstInput && firstInput[0]) {
              firstInput[0].focus();
            }
          }, firstLoad === true ? 500 : 100);

          App.modalCurrentPage = pageToShow;
        }

        $('#loginModal').on('show.bs.modal', function (event) {
          clearErrorMessage('login-form', 'login');
          showPage('login', true);
        });

        $('#loginModal').on('hidden.bs.modal', function (event) {
          $(this).removeClass('show-offer-message');
        });


        $("#retypepassword-form").submit(function (event) {
          event.preventDefault();
          clearErrorMessage('retypepassword-form', 'retype');

          var form = $(this);
          url = '/user/retype-password';

          var data = form.serialize();
          console.log('sending data to', url, data);
          $.post(url, data)
            .done(function (response) {
              if (response && response.message) {
                showSuccessMessage('retype-success-message', response.message);

                // timeout
                setTimeout(function () {
                  window.location = '/';
                }, 4000);
              }
            })
            .fail(function (err) {
              if (err && err.responseJSON && err.responseJSON.message) {
                showErrorMessage('retype-message', err.responseJSON.message);
                if (err && err.responseJSON && err.responseJSON.validation_messages) {
                  showFormErrors('retype', err.responseJSON.validation_messages);
                }
                console.log('ERROR', err);
              } else {
                showErrorMessage('retype-message', 'Wystąpił nieznany błąd');
              }
            });
        });

        $("#login-form").submit(function (event) {
          event.preventDefault();
          clearErrorMessage('login-form', 'login');

          var form = $(this);
          var url = '';
          switch (App.modalCurrentPage) {
            case 'login':
              url = '/user/login';
              break;
            case 'registration':
              url = '/user/register';
              break;
            case 'remind':
              url = '/user/remind';
              break;
          }

          var data = form.serializeArray();
          var dataToSend = [];
          for (var i = 0; i <= data.length; i++) {
            switch (App.modalCurrentPage) {
              case 'login':
                dataToSend = data.filter(function (el) {
                  return el.name.startsWith('authorization[');
                });
                break;
              case 'remind':
                dataToSend = data.filter(function (el) {
                  return el.name.startsWith('remind[');
                });
                break;
              case 'registration':
                dataToSend = data.filter(function (el) {
                  return el.name.startsWith('registration[');
                });
                break;
            }
          }
          data = $.param(dataToSend);
          console.log('sending data to', url, data);
          $.post(url, data)
            .done(function (response) {
              if (response && response.message) {
                showSuccessMessage('login-success-message', response.message);
              }
              if (App.modalCurrentPage === 'login') {
                window.location.reload();
              } else if (App.modalCurrentPage === 'registration') {
                // $('#page-' + App.modalCurrentPage).hide();
                showPage('registrationDone');
              }
            })
            .fail(function (err) {
              if (err && err.responseJSON && err.responseJSON.message) {
                showErrorMessage('login-message', err.responseJSON.message);
                if (err && err.responseJSON && err.responseJSON.validation_messages) {
                  showFormErrors(App.modalCurrentPage, err.responseJSON.validation_messages);
                }
                console.log('ERROR', err);
              } else {
                showErrorMessage('login-message', 'Wystąpił nieznany błąd');
              }
            });
        });

        $('#user_data_form').submit(function (event) {
          event.preventDefault();

          var form = $(this);
          var url = form.attr('action');
          var data = form.serialize();
          clearErrorMessage('user_data_form', 'userdata');
          clearErrorMessage('user_password_form', 'userpassword');

          $.post(url, data)
            .done(function (jsonObj) {
              console.log(jsonObj);
              showSuccessMessage('userdata-success-message', jsonObj.message);
            })
            .fail(function (err) {
              console.log('FAIL', err);
              if (err && err.responseJSON && err.responseJSON.message) {
                showErrorMessage('userdata-message', err.responseJSON.message);
                if (err && err.responseJSON && err.responseJSON.validation_messages) {
                  showFormErrors('userdata', err.responseJSON.validation_messages);
                }
                console.log('ERROR', err);
              } else {
                showErrorMessage('userdata-message', 'Wystąpił nieznany błąd');
              }
            });
        });

        $('#user_password_form').submit(function (event) {
          event.preventDefault();

          var form = $(this);
          var url = form.attr('action');
          var data = form.serialize();
          clearErrorMessage('user_data_form', 'userdata');
          clearErrorMessage('user_password_form', 'userpassword');

          $.post(url, data)
            .done(function (jsonObj) {
              console.log(jsonObj);
              showSuccessMessage('userpassword-success-message', jsonObj.message);
            })
            .fail(function (err) {
              console.log('FAIL', err);
              if (err && err.responseJSON && err.responseJSON.message) {
                showErrorMessage('userpassword-message', err.responseJSON.message);
                if (err && err.responseJSON && err.responseJSON.validation_messages) {
                  showFormErrors('userpassword', err.responseJSON.validation_messages);
                }
                console.log('ERROR', err);
              } else {
                showErrorMessage('userpassword-message', 'Wystąpił nieznany błąd');
              }
            });
        });

          function addProductToOffer(url, count, contactData) {
            count = count || 1;
            contactData = contactData || null;
            return $.ajax(url, {
              method: 'POST',
              contentType: "application/json; charset=utf-8",
              dataType: "json",
              data: JSON.stringify({
                count: count,
                contactData: contactData
              }),
              beforeSend: function() {
                resetFormErrors();
              }
            });
          }

          function resetFormErrors() {
            $('#offerModal .form-errors').html('');
          }
          /* end dodawanie do ofertownika modal */

          /* wysyłanie zapytania z ofertownika */


          $('body').on('click', '.sendOffer', function(e) {
            e.preventDefault();
            sendOffer($(this).data('param'));
          });

          function sendOffer(withContactData) {

            withContactData = withContactData || false;
            var url = '/offer/mail',
                div = '#mailreturn',
                contactDiv = '#offer-mail-contact';

            var contactData = (withContactData === true) ? {
                name: $('#offercontact-input-contact_name').val(),
                company: $('#offercontact-input-forname').val(),
                email: $('#offercontact-input-email').val(),
                phone: $('#offercontact-input-phone').val()
              }
              : null;


            jQuery.ajax({
              url: url,
              dataType: 'json',
              data: contactData,
              type: "POST",
              success: function(data){

                $(div).addClass('loading');
                $(div).removeClass('alert alert-success');
                $(div).removeClass('alert alert-danger');
                $(div).removeClass('alert alert-info');
                $(contactDiv).removeClass('show');
                $(div).html('<img src="http://promocyjne.pl/images/wait.gif" alt="loading..." />');
                $(div).removeClass('loading');

                  if (data.success === true) {
                    $(div).addClass('alert alert-success');
                    $(div).html(data.msg);
                  } else {
                    if (data.need_contact_data === true) {
                      $(div).addClass('alert alert-info');
                      $(div).html(data.msg);
                      $(contactDiv).addClass('d-block');
                    } else {
                      $(div).addClass('alert alert-danger');
                      $(div).html(data.msg);
                    }
                  }

              },
              error: function(data){
                $(div).addClass('alert-danger');
                $(div).html('Błąd serwera. Oferta nie została wysłana.');
              }
            });

          }

          /* end wysyłanie zapytania z ofertownika */

          /* ofertownik komentarz */
          $('body').on('click', '.add_comment', function(e) {
            e.preventDefault();
            editCommentClient($(this).data('key'));
          });

          function editCommentClient(productId){
           var layer = '#offer_area_'+productId;
           var layerComment = '#offer_comment_'+productId;
            $(layer).css('display', 'block');
            $(layerComment).css('display', 'none');
            $('#a_save_'+productId).css('display', 'inline');
            $('#a_cancel_'+productId).css('display', 'inline');
            $('#a_edit_'+productId).css('display', 'none');
          }

          $('body').on('click', '.cancel_comment', function(e) {
            e.preventDefault();
            cancelEditCommentClient($(this).data('key'));
          });

          function cancelEditCommentClient(productId){
            layer = '#offer_area_'+productId;
            layerComment = '#offer_comment_'+productId;
            divError = '#error_comment_'+productId;
            $(layer).css('display', 'none');
            $(layerComment).css('display', 'block');
            $(divError).empty();
            $('#a_save_'+productId).css('display', 'none');
            $('#a_cancel_'+productId).css('display', 'none');
            $('#a_edit_'+productId).css('display', 'inline');
          }

          $('body').on('click', '.save_comment', function(e) {
            e.preventDefault();
            saveCommentClient($(this).data('key'));
          });

          function saveCommentClient(productId){
            var url = '/offer/addcomment';
            var productid = productId;
            var comment = $('#offer_area_'+productId).val();
            jQuery.ajax({
              url: url,
              dataType: 'json',
              data: { productid: productid, comment: comment },
              type: "POST",
              success: function(data){
                $('#error_comment_'+productid).html('');
                div = '#offer_comment_'+productid;
                divError = '#error_comment_'+productid;
                if (data.result == 1) {
                  $('#a_save_'+productid).css('display', 'none');
                  $('#a_cancel_'+productid).css('display', 'none');
                  $('#a_edit_'+productid).css('display', 'inline');
                  $('#offer_area_'+productid).css('display', 'none');
                  $(div).css('display', 'block');
                  $(div).html(data.value);
                  $(divError).html('');
                } else {
                  $(divError).html(data.value);
                }
              }
            });
          }
          /* end ofertownik komentarz */



      },
      finalize: function() {
        // JavaScript to be fired on all pages, after page specific JS is fired
      }
    },
    // Home page
    'home': {
      init: function() {

          /* blog slider */
          jQuery(".block-recent-posts .ptowl").owlCarousel({
            autoplay: true,
            autoplayHoverPause: true,
            loop: true,
            items : 2,
            responsiveClass:true,
            responsive:{
                0:{
                    items:1
                },
                960:{
                    items:2
                }
            },
            slideSpeed : 500,
            paginationSpeed : 500,
            rewindSpeed : 500,
            addClassActive: true,
            nav : true,
            stopOnHover : true,
            dots : false,
            scrollPerPage:true,
            lazyLoad:true
          });

          /* wybrane kategorie */
          jQuery(".pt_categorytop .categorytop_slider").owlCarousel({
            autoplay: true,
            autoplayHoverPause: true,
            loop: true,
            slideSpeed : 500,
            nav : true,
            stopOnHover : true,
            dots : false,
            items : 3,
            responsiveClass:true,
            responsive:{
                0:{
                    items:1
                },
                576:{
                    items:2
                },
                960:{
                    items:3
                }
            },
            addClassActive : true,
            scrollPerPage:false,
            lazyLoad:true
          });

      },
      finalize: function() {
        // JavaScript to be fired on the home page, after the init JS
      }
    },
    // About us page, note the change from about-us to about_us.
    'about_us': {
      init: function() {
        // JavaScript to be fired on the about us page
      }
    }
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = App;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';
      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.
